import { PlatformConfigResponse } from './platform-config.response';
import { PlatformConfigState } from './platform-config.state';

/**
 * Pure wire → state mapper for the platform config endpoint. Increment bands
 * are sorted ascending so `resolveBidIncrement` can take the first match.
 */
export function mapPlatformConfigResponse(response: PlatformConfigResponse): PlatformConfigState {
  return {
    ...response,
    bidIncrements: [...response.bidIncrements].sort(
      (a, b) => (a.maxPrice ?? Number.POSITIVE_INFINITY) - (b.maxPrice ?? Number.POSITIVE_INFINITY)
    ),
    localFindsRadiiMi: [...response.localFindsRadiiMi]
  };
}
